import React, { useState, useEffect, lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import withSection from "../withSection";

import Carousel from "./Carousel";
import Gallery from "../../Gallery";

// TODO: to increase per_page calls, check out Section.js's URL for useFetch

const Work = ({
  data,
  location,
  history,
  lang,
  onNextSection,
  onScrollToTop,
  onModal,
  ...props
}) => {
  const [locationData, setLocationData] = useState({
    paths: [],
    index: undefined
  });
  useEffect(() => {
    const slugs = data && data.map(v => v.slug);
    const paths = slugs.map(v => "/works/" + v);
    const links = paths.map(p => decodeURI(p));
    // let current = location && decodeURI(location.pathname).slice(0, -1); // TODO: GAH this trailing slash thing
    let current = location && decodeURI(location.pathname);
    if(current) {

      const sp = current.split("/");
      if(sp[sp.length-1] === "") current = decodeURI(current).slice(0, -1);

    }
    const fullpath = links.filter(v => v.includes(current))[0];
    const index = fullpath && links.indexOf(fullpath);
    setLocationData({
      paths: paths,
      index: index
    });
  }, [data, location]);

  // set data for detail page
  const [modalContent, setModalContent] = useState({});
  const handleClick = e => {
    setModalContent(e);
    onScrollToTop && onScrollToTop();
  };
  useEffect(() => {
    // set modal
    if (locationData.index >= 0 && locationData.index !== -1) {
      const modalData = data[locationData.index].acf;
      handleClick(modalData);
    } else {
      // handleExit();
    }
  }, [locationData.index, location, data, handleClick]);

  // get only wordpress acf data
  const results = (data && data.map(v => v.acf)) || [];

  // handle carousel pagination
  const handlePaginate = direction => {
    history.push(locationData.paths[locationData.index + direction]);
    onScrollToTop && onScrollToTop();
  };



  // console.log("Work.modalContent:", modalContent);
  // console.log("Work.locationData:", locationData);
  // const [intersectionData, ref] = useIntersect();
  // console.log("ref", ref);
  // console.log("data", intersectionData);

  // TODO: auto open next section once you reach the bottom
  // of the current section
  // useEffect(() => {
  //   // setTimeout(() => {
  //   //   onNextSection && onNextSection("teams");
  //   // }, 1000);
  // }, []);

  return (
    <Route
      path={"/works"}
      render={() => (
        <>
          <Route
            key="carousel-route"
            path={"/works/:subsection"}
            render={({ ...rest }) => (
              <Carousel
                data={modalContent}
                allData={data}
                onPaginate={handlePaginate}
                onModal={onModal}
                lang={lang}
                {...props}
                {...rest}
              />
            )}
          />
          <Route
            key="gallery-route"
            path={"/works"}
            exact
            render={() => (
              <Gallery
                type="works"
                data={results}
                paths={locationData.paths}
                lang={lang}
                onClick={handleClick}
              />
            )}
          />
        </>
      )}
    />
  );
};

export default withSection(Work);
